import * as yup from 'yup';
import { stringFieldDefault } from 'components/Utility';
import { DATA_TYPE_ADDRESS, DATA_TYPE_COUNTY, DATA_TYPE_HYPERLINK, DATA_TYPE_GEOCODE } from "typeConstants/dataTypes";

const getDataType = (properties, propertyName) => {
  if (properties?.includes(stringFieldDefault))
    return null;
  switch (propertyName) {
    case 'addressLink':
      return DATA_TYPE_HYPERLINK;
    case 'address':
      return DATA_TYPE_ADDRESS;
    case 'county':
      return DATA_TYPE_COUNTY;
    case 'geocode':
      return DATA_TYPE_GEOCODE;
  }
};

export const getSubjectAddressFields = (
  {
    address,
    county,
    state,
    geocode,
    rawAddress: {
      address1,
      address2,
      city,
      zip,
    }
  },
  onAddressClick,
  isIndented = false,
) => [{
  key: 'address',
  label: 'Address',
  value: onAddressClick
    ? { label: address, onClick: () => onAddressClick() }
    : address,
  dataType: onAddressClick
    ? getDataType(address, 'addressLink')
    : getDataType(address, 'address'),
  editFields: [{
    key: "surveyAddress1",
    label: "Address Line 1 *",
    value: address1,
    validation: yup.string().required("Address Line 1 is a required field"),
  },
  {
    key: "surveyAddress2",
    label: "Address Line 2",
    value: address2,
  },
  {
    key: "surveyCity",
    label: "City *",
    value: city,
    validation: yup.string().required("City is a required field"),
  },
  {
    key: "surveyZip",
    label: "Zip *",
    value: zip,
    validation: yup.number().typeError("Zip must be a number").positive("Zip cannot be negative").required("Zip is a required field"),
  },
  {
    key: "surveyCounty",
    label: "County *",
    value: county,
    validation: yup.string().required("County is a required field"),
  }]
},
{
  key: 'county',
  label: 'County',
  value: `${county}/${state}`,
  dataType: getDataType([county, state], 'county'),
  editable: false,
  editFields: [],
},
{
  key: 'geocode',
  label: 'Geocode',
  value: geocode,
  editable: false,
  editFields: [],
}].map(({ key, ...field }) => ({
  ...field,
  key: `subject-${key}`,
  isIndented
}));

export const getMailingAddressFields = (
  {
    address,
    rawAddress: {
      address1,
      address2,
      city,
      zip,
    },
  },
  isIndented = false,
) => [{
  key: 'address',
  label: 'Address',
  value: address,
  dataType: DATA_TYPE_ADDRESS,
  editFields: [{
    key: "mailingAddress1",
    label: "Address Line 1 *",
    value: address1,
    validation: yup.string().required("Address Line 1 is a required field")
  },
  {
    key: "mailingAddress2",
    label: "Address Line 2",
    value: address2,
  },
  {
    key: "mailingCity",
    label: "City *",
    value: city,
    validation: yup.string().required("City is a required field")
  },
  {
    key: "mailingZip",
    label: "Zip *",
    value: zip,
    validation: yup.number().typeError("Zip must be a number").positive("Zip cannot be negative").required("Zip is a required field")
  }
  ]
}].map(({ key, ...field }) => ({
  ...field,
  key: `mailing-${key}`,
  isIndented
}));

